import styled from 'styled-components';
import Flex from 'Shared/ui/Flex';
import T from 'aegisv2/Text';

import CareerBanner from 'SharedCareers/CareerBanner';
import { primaryMain } from 'crehana-ui/styles/colors';

import Pagination from '../../Pagination';

export const WrapperCSS = `
border-radius: 5px;
padding: 0px;
flex-direction: column;
align-items: center;
@media (min-width: 678px) {
  flex-direction: row;
}
@media (min-width: 1366px) {
  padding: 0;
}
`;

export const PaginationWrapper = styled(Flex)`
  ${WrapperCSS};
  @media (min-width: 678px) {
    justify-content: flex-end;
  }
`;

export const ContentTopWrapper = styled(Flex)`
  margin-top: 20px;
  position: relative;
  ${WrapperCSS}
  align-items: flex-start;
  margin-bottom: 24px;
  @media (min-width: 678px) {
    flex-flow: column;
    margin-bottom: 34px;
  }
`;

export const ResultsTitle = styled(Flex)`
  font-family: Nunito, sans-serif;
  margin-top: 24px !important;
  text-align: left;

  @media (min-width: 1140px) {
    margin-top: 0;
  }
`;

export const ScrollTopIconWrapper = styled.div`
  transform: rotate(90deg);
  margin-right: 11px;
`;

export const ScrollTopWrapper = styled(Flex)`
  cursor: pointer;
  margin-bottom: 24px;
  @media (min-width: 678px) {
    margin-right: 22px;
    margin-bottom: 0;
  }
`;

export const EmptySubTitle = styled(T)`
  display: block;
  margin-top: 8px;
  margin-bottom: 8px;
`;

export const StyledPagination = styled(Pagination)`
  display: none;
  @media (min-width: 768px) {
    margin: 0;
    display: flex;
  }
`;

// catalog-careers, enable eslint if it is necessary
// eslint-disable-next-line no-unused-vars
export const CareerBannerWrapper = styled(CareerBanner)`
  min-height: 345px;
  height: auto;

  margin-bottom: 30px;
  @media (min-width: 768px) {
    min-height: 256px;
    margin-bottom: 25px;
  }
`;

export const TagMobile = styled.div`
  display: block;
  @media (min-width: 768px) {
    display: none;
  }
`;

export const SelectWrapper = styled.div`
  margin-top: 28px;
  display: flex;
  flex-flow: row;
  width: 100%;
  & > div {
    display: flex;
    align-items: center;
    & > span {
      display: inline-block;
      margin-right: 24px;
    }
    &:first-child {
      margin-right: 14px;
    }
    @media (min-width: 680px) {
      &:first-child {
        margin-right: 40px;
      }
    }
  }

  @media (min-width: 1140px) {
    margin-top: 20px;
  }
`;

export const SelectLabel = styled(T)`
  display: none !important;
  @media (min-width: 680px) {
    display: inline-block !important;
  }
`;

export const FadeIn = styled.div`
  opacity: ${props => (props.visible ? 1 : 0)};
  transition: opacity 0.5s ease-in-out 0.5s;
  .filterSelect__single-value {
    color: ${primaryMain};
  }
`;

export const SubCategoryTag = styled.div`
  background-color: #fafafa;
  border-radius: 5px;
  padding: 6px 16px;
  text-align: center;
  cursor: pointer;
  width: fit-content;
  transition: 0.2s opacity ease-in-out;

  ${props =>
    props.selected &&
    `
    background-color: #0099ff;
    border: 0px solid transparent;
  `}
  ${props =>
    props.disabled &&
    `
    opacity: 0.3;
    cursor: not-allowed;
  `}
`;

export const SubCategoryTagContainer = styled.div`
  width: calc(100vw - 32px);
  @media (min-width: 680px) {
    width: 100%;
    display: flex;
    flex-flow: row wrap;
    & > ${SubCategoryTag} {
      margin-bottom: 16px;
      &:not(:last-child) {
        margin-right: 16px;
      }
    }
  }
`;

export const SlidesWrapper = styled.div`
  position: relative;
  overflow: visible;
`;

export const Slides = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  overflow-x: auto;
  position: relative;
  z-index: 9;
  scroll-behavior: smooth;
`;

export const HideScrollBarElement = styled.div`
  position: absolute;
  background-color: #fff;
  height: 12px;
  bottom: -3px;
  right: 0;
  left: 0;
  z-index: 999;
`;

export const Slide = styled.div`
  width: auto;
  flex-shrink: 0;
  height: 100%;
  &:not(:last-child) {
    margin-right: 5px;
  }
`;

export const Mobile = styled.div`
  display: block;
  @media (min-width: 680px) {
    display: none;
  }
`;

export const Desktop = styled.div`
  display: none;
  @media (min-width: 680px) {
    display: block;
  }
`;

export const DesktopStyled = styled.div`
  display: none;
  @media (min-width: 680px) {
    display: flex;
    flex-flow: wrap;
    width: 100%;
  }
`;

export const SearchContainer = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto;
  display: flex;
  padding-bottom: ${props => (props.isOrganization ? '55' : '0')}px;
  flex-direction: column;
  @media (min-width: 768px) {
    margin: 0px auto 20px;
    ${props =>
      props.marginBottom &&
      `
      margin-bottom: ${props.marginBottom};
    `}
    width: calc(100% - 64px);
  }

  @media (min-width: 1140px) {
    margin-top: ${props => props.marginTop || '0px'};
  }

  @media (min-width: 1280px) {
    width: 1140px;
  }

  @media (min-width: 1440px) {
    width: 1280px;
  }
`;

export const Container = styled.div`
  width: calc(100% - 32px);
  margin: 0 auto 20px;
  @media (min-width: 768px) {
    width: calc(100% - 64px);
  }

  @media (min-width: 1280px) {
    width: 1140px;
  }

  @media (min-width: 1440px) {
    width: 1280px;
  }
`;

export const HighlightedWrapper = styled.div`
  background: #fafafa;
  width: calc(100% - 32px);
  margin: 0 auto 40px;
  @media (min-width: 768px) {
    margin: 0 auto 50px;
    width: calc(100% - 64px);
    padding: 0;
  }

  @media (min-width: 1140px) {
    display: flex;
    justify-content: space-between;
  }

  @media (min-width: 1280px) {
    width: 1140px;
  }

  @media (min-width: 1440px) {
    width: 1280px;
  }
`;

export const SearchCardWrapper = styled.div`
  padding: 24px 0;
  @media (min-width: 768px) {
    padding: 28px 0;
    margin: 0 auto;
  }
  @media (min-width: 1024px) {
    max-width: 700px;
  }
  @media (min-width: 1140px) {
    margin: 0;
    /* max-width: unset; */
    padding: 37px 0;
    width: calc(calc(100% - 32px) / 2);
  }
`;
